module.exports = __webpack_public_path__ + "img/announcement-megaphone-white.3a0afdde.svg";